/* eslint-disable */

export default {
  init() {
    // JavaScript to be fired on the Magazine page
    const $doc = $(document);
    const $win = $(window);

    $('.featured-articles__wrapper').append('<div class="loading-icon" style="width:100%;height:120px;position:relative;"><i class="far fa-spinner fa-pulse fa-2x" style="position:absolute;top:50%;color:#696060;left:50%;transform:translate3d(-50%,-50%,0);"></i></div>');


    $win.on('load', () => {
      $('.featured-articles__container').css({"opacity":"1", "height":"auto"});
      if ( $('.loading-icon').length ) {
        $('.loading-icon').fadeOut(200).remove();
      }
    });


    // debounce so filtering doesn't happen every millisecond
    function debounce( fn, threshold ) {
      let timeout;
      return function debounced() {
        if ( timeout ) {
          clearTimeout( timeout );
        }
        function delayed() {
          fn();
          timeout = null;
        }
        timeout = setTimeout( delayed, threshold || 100 );
      };
    }

    // quick search regex
    let qsRegex;

    // init Isotope
    const $grid = $('.blog__grid').isotope({
      itemSelector: '.blog__post',
      layoutMode: 'fitRows',
      initLayout: true,
      getSortData: {
        alphabetically: '.blog__post-title',
        date(elem) {
          return Date.parse($(elem).find('.blog__post-meta').text());
        }
      },
      filter() {
        const $this = $(this);
        // first get the value of the topic filter
        const dropdownVal = $('.blog__form-filter').find('option:selected').val();

        // factor the value into the search filter
        const matchedText = dropdownVal ? $this.is( dropdownVal ) : true;

        const searchResult = qsRegex ? $this.text().match( qsRegex ) : true;

        return searchResult && matchedText;
      }
    });

    // use value of search field to filter
    const $quicksearch = $('.quicksearch').keyup( debounce( () => {
      qsRegex = new RegExp( $quicksearch.val(), 'gi' );
      $grid.isotope();
    }, 200 ) );

    //Filter Select
    $('.bootstrap-select').on( 'changed.bs.select', function(event, clickedIndex, newValue, oldValue) {
      // first check the value of the search field
      // grab the value, if any, and include it into the filter
      const filterValue = $(this).find('option').eq(clickedIndex).val();
       $grid.isotope();
     });

     // Remove .selected option from category dropdown
     $('.blog__form-filter').on( 'show.bs.select', function(e) {
       $(this).find('li.selected').addClass('hidden');
     });

     $('.blog__form-filter').on( 'hidden.bs.select', function(e) {
       $(this).find('li.hidden').removeClass('hidden');
     });

     // Remove .selected option from sorting dropdown
     $('.blog__form-sort').on( 'show.bs.select', function(e) {
       $(this).find('li.selected').addClass('hidden');
     });

     $('.blog__form-sort').on( 'hidden.bs.select', function(e) {
       $(this).find('li.hidden').removeClass('hidden');
     });


    //Sort Select
    $('.blog__form-sort').on( 'changed.bs.select', function(event, clickedIndex, newValue, oldValue) {
      const $option = $(this).find('option').eq(clickedIndex);
      let sortValue = $option.val();
      let ascending = true;

      if ( $option.data('ascending') !== undefined ) {
        ascending = $option.data('ascending');
      }

      // make an array of values
      sortValue = sortValue.split(',');

      $grid.isotope({
        sortBy: sortValue,
        sortAscending: ascending
      });
    });

    // matchHeight.js
    $(() => {
      $('.blog__post-content-wrapper').matchHeight({
        byRow: false
      });
      $grid.isotope();
    });

    const $noPosts = $('.blog__form-search').keyup( debounce( () => {
      const numPosts = $grid.data('isotope').filteredItems.length;
      if (numPosts >= 1) {
        $('#msg-box').css({"opacity":"0", "height":"0", "padding":"0"});
      } else {
        $('#msg-box').css({"opacity":"1", "height":"auto", "padding":"60px 0"});
      }

      const userInput = $('.blog__form-search').val();
      $('.blog__no-results--user-input').html(userInput);
    }, 250 ) );

    // Function to lazy load magazine posts
    function lazyLoadPosts(url, dataObj, security, action) {

      const $promise = $.ajax({
        url: magazine.ajaxUrl,
        method: 'post',
        dataType: 'json',
        data: {'json': dataObj, 'security': security, 'action': action }
      });

      // If there are posts, display them
      $promise.done((response, textStatus, jqXhr) => {
        if (response.data.showLoadMoreButton === true) {
          let posts = '';
          if (response.status === 'success' && response.data.posts.length){

            // Magazine post template
            response.data.posts.forEach((e, i) => {
              posts += `<div class="blog__post ${e.post_category}"><a class="blog__post-link" href="${e.post_permalink}"><div class="blog__post-tile"><div class="blog__post-image" style="background-image:url(${e.post_permalink_url[0]}"></div><div class="blog__post-content-wrapper"><div class="blog__post-content"><h4 class="blog__post-title">${e.post_title}</h4><p class="blog__post-meta" data-date="${e.post_data_date}">${e.post_date}</p><p class="blog__post-category hidden">${e.post_category}</p><p class="blog__post-excerpt hidden">${e.post_excerpt}</p><p class="blog__post-excerpt hidden">${e.post_category_name}</p></div></div></div></a></div>`;
            });
            // append items to grid
            let newItems = $(posts).appendTo( $grid );
            $grid.isotope( 'appended', $(newItems) );
            $grid.isotope();
          }
        } else {
          // Hide button if no more posts
          $('.blog__load-more')
            .css("opacity", "0")
            .remove();
        }
        if (response.data.offset + response.data.postsperpage  > parseInt(response.data.total_posts)) {
          $('.blog__load-more')
            .css("opacity", "0")
            .remove();
        }
      });

      $promise.fail((jqXhr, textStatus, errorThrown) => {
        console.log(jqXhr);
        console.log(textStatus);
        console.log(errorThrown);
      });

      // Apply matchHeight.js and change button back to default
      $grid.on( 'layoutComplete', (event, laidOutItems) => {
        $('.blog__post-content-wrapper').matchHeight({
          byRow: false
        });
        $('.blog__load-more-button').find('.fa-spinner').css("color", "transparent");
        $('.blog__load-more-button').css("color", "#fff");
      });
    };

    // Load more posts button
    $('.blog__load-more-button').on( 'click', event => {
      $('.blog__load-more-button')
      .css("color", "transparent")
      .append('<div class="loading-icon" style="position:absolute;top:50%;left:50%;transform:translate3d(-50%, -50%, 0)"><i class="far fa-spinner fa-pulse" style="color:#fff;"></i></div>');

      // Ajax Request
      lazyLoadPosts( magazine.ajaxUrl, {'test':"testing"}, magazine.nonce, 'loadMagazinePosts' );
    });
  },
  finalize() {
    // JavaScript to be fired on the Magazine page, after the init JS
    // $grid.isotope('reloadItems');
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/magazine.js